module.exports = __webpack_public_path__ + "static/img/spot_send_success_icon.f590e77b.png";